export default __webpack_public_path__ + "static/media/0x5647fe4281f8f6f01e84bce775ad4b828a7b8927.32255261.webp";